import { Directive, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[ngx-google-places-autocomplete]',
  exportAs: 'ngx-places',
  standalone: true
})
export class NgxGooglePlacesAutocompleteDirective implements OnInit {
  @Input() options: any;
  @Output() placeChanged = new EventEmitter<any>();

  private autocomplete: any;

  constructor(private elementRef: ElementRef<HTMLInputElement>) {}

  ngOnInit(): void {
    const w: any = window as any;
    if (w.google && w.google.maps && w.google.maps.places) {
      this.autocomplete = new w.google.maps.places.Autocomplete(
        this.elementRef.nativeElement,
        this.options || {}
      );
      this.autocomplete.addListener('place_changed', () => {
        const place = this.autocomplete.getPlace();
        this.placeChanged.emit(place);
      });
    }
  }
}


